import { render, staticRenderFns } from "./StorerTable.vue?vue&type=template&id=0b862f94"
import script from "./StorerTable.vue?vue&type=script&lang=js"
export * from "./StorerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports